import React, { useContext, useEffect } from 'react';

import { PersonalInfo, Field, } from '../../core/inputElements';
import { StepContext, Section, FormContext, ExpandableMessagePane, EMESection } from '../../core/layoutElements'; 
import { printOnPaper, callWithRecaptcha, updateFormData } from '../../core/reducers/formDetail';
import { RootContext } from '../../root';
import { useDispatch, useSelector } from 'react-redux';
import useFieldHandlers from '../../core/hooks/use-emefield-handlers.hook';

const STEPID = "steps_Particulars";
const TITLE = "steps_Particulars";
const part_1_ID = "part_1_Particulars";
const part_2_ID = "part_2_MDB";
const part_3_ID = "part_3_SignInfo";
const part_4_ID = "part_4_AutopayFacility";

// const SECTION_PARTICULARS = "particulars";

const Particulars = (props) => {
    const {formLocalization, submitTransformFunc, submitDateId, readOnly, stepIdx } = useContext(FormContext);
    const {recaptcha} = useContext(RootContext);
    const {formData} = useSelector(store => store.formDetail);
    const dispatch = useDispatch();
    const { handleFieldChange, getFieldStatus } = useFieldHandlers(); 

    const calculateFeesAndDeposits = (application, deposit, suppLoginNo) => {
        let depositStr = deposit ? deposit.replace(/,/g,'') : "" ; // .replaceAll(',','') : "";
        var _totalFee =  (application ? 1500 : 0) + (isNaN(parseInt(depositStr)) ? 0 : parseInt(depositStr)) + (750 * (isNaN(parseInt(suppLoginNo)) ? 0 : parseInt(suppLoginNo)));
        return _totalFee.toString();
    }

    useEffect(() => {
        const titleMapping = {
            'Mr'    : "0",
            'Miss'  : "1",
            'Mrs'   : "2",
            'Ms'    : "3",
        };
        if (formData.Respect && titleMapping[formData.Respect] !== undefined) {
            const numericTitle = titleMapping[formData.Respect];
            dispatch(updateFormData(null, null, { Respect: numericTitle }));
        }
        if (!getFieldStatus("BR_CR_PI_PN").edited && getFieldStatus("BR_CR_PI_PN").autofilled) {
            dispatch(updateFormData(null, null, { ["BR_CR_PI_PN_Type"] :  "3"}));
        }
    }, [formData.Respect, formData.BR_CR_PI_PN]);
    
    return ( 
        <StepContext.Provider value={{stepId: STEPID, title: TITLE, validations: {}}}>
            {stepIdx === 2 && <EMESection />}
            <Section id={part_1_ID} titleText={formLocalization.part_1_Particulars} inline={props.inline} >
                <Field.Text id="SubscriberName" label={formLocalization.SubscriberName} groupNotes={formLocalization.SubscriberNameSubLabel} maxlength={100} required multiline={true} 
                            eMeLabel={getFieldStatus("SubscriberName").autofilled && !getFieldStatus("SubscriberName").edited} 
                            onChange={(value) => handleFieldChange("SubscriberName", value)} />
                <Field.LookupAddress id="BusinessAddress" label={formLocalization.BusinessAddress} maxlength={200} required multiline={true} />
                <PersonalInfo.Email id="Email" label={formLocalization.Email} required maxlength={100} 
                                    eMeLabel={getFieldStatus("Email").autofilled && !getFieldStatus("Email").edited} 
                                    onChange={(value) => handleFieldChange("Email", value)} />
                <PersonalInfo.PhoneFax id="OLS1_TelNo" label={formLocalization.OLS1_TelNo} maxlength={20} required
                                       eMeLabel={getFieldStatus("OLS1_TelNo").autofilled && !getFieldStatus("OLS1_TelNo").edited} 
                                       onChange={(value) => handleFieldChange("OLS1_TelNo", value)} />
                <PersonalInfo.PhoneFax id="OLS1_FaxNo" label={formLocalization.OLS1_FaxNo} maxlength={20} />
                {/* <Field.Text id="CSP_MemNo" label={formLocalization.CSP_MemNo} maxlength={20} /> Removed by SCR-14542 */}
                <Field.Dropdown id="BR_CR_PI_PN_Type" label={formLocalization.BR_CR_PI_PN_Type} required  
                                strike={true} 
                                options={formLocalization.field_BR_CR_PI_PN_Type_list} />
                <Field.Text id="BR_CR_PI_PN" label={formLocalization.BR_CR_PI_PN} maxlength={30} required alphanumericHyphen 
                            eMeLabel={getFieldStatus("BR_CR_PI_PN").autofilled && !getFieldStatus("BR_CR_PI_PN").edited} 
                            onChange={(value) => handleFieldChange("BR_CR_PI_PN", value)} />
                <Field.Dropdown id="Respect" label={formLocalization.Respect} strike={true} options={formLocalization.field_Respect_list} required 
                                eMeLabel={getFieldStatus("Respect").autofilled && !getFieldStatus("Respect").edited} 
                                onChange={(value) => handleFieldChange("Respect", value)} />
                <Field.Text id="OLS1_ContactPerson" label={formLocalization.OLS1_ContactPerson} maxlength={100} required 
                            eMeLabel={getFieldStatus("OLS1_ContactPerson").autofilled && !getFieldStatus("OLS1_ContactPerson").edited} 
                            onChange={(value) => handleFieldChange("OLS1_ContactPerson", value)} />
                <Field.Dropdown id="BusinessType" label={formLocalization.BusinessType} required strike={true} options={formLocalization.field_businessType_list} />
                <Field.Text id="OLS1_BankName" label={formLocalization.OLS1_BankName} maxlength={60} required multiline={true} />
                <Field.Text id="AccountNo" label={formLocalization.AccountNo} maxlength={20} numericHyphen required />
                <Field.Text id="AccountHolder" label={formLocalization.AccountHolder} maxlength={100} required multiline={true} />
                <Field.Dropdown id="LoginMethod" label={formLocalization.LoginMethod} required options={formLocalization.field_loginMethod_list} />
                <Field.Text id="HongKongPostRefNo" label={formLocalization.HongKongPostRefNo} maxlength={25} required 
                            hideWhen={formData.LoginMethod !== "1"} />
                <Field.Text id="DigiSignRefNo" label={formLocalization.DigiSignRefNo} maxlength={25} required 
                            hideWhen={formData.LoginMethod !== "2"} />
            </Section> 
            <Section id={part_2_ID} titleText={formLocalization.part_2_MDB} inline={props.inline}>
                <Field.Checkbox id="FeeForApplication" label={formLocalization.FeeForApplication} required
                            onValChange={v => {
                                dispatch(updateFormData(null,null,{ FeesAndDeposits: calculateFeesAndDeposits(v, v?formData.DepositAmount:0, formData.SupplementaryLoginNo)})) 
                            }} />
                <Field.Text id="DepositAmount" label={formLocalization.DepositAmount} required numericComma maxlength={5}
                            decimalMin={500}
                            onValChange={v => {
                                dispatch(updateFormData(null,null,{ FeesAndDeposits: calculateFeesAndDeposits(formData.FeeForApplication, v, formData.SupplementaryLoginNo)})) 
                            }}
                            hideWhen={!formData.FeeForApplication} />
                <Field.Checkbox id="FeeForSupplementaryLoginID" label={formLocalization.FeeForSupplementaryLoginID} 
                            onValChange={v => {
                                dispatch(updateFormData(null,null,{ FeesAndDeposits: calculateFeesAndDeposits(formData.FeeForApplication, formData.DepositAmount, v?formData.SupplementaryLoginNo:0)})) 
                            }}/>
                <Field.Text id="SupplementaryLoginNo" label={formLocalization.SupplementaryLoginNo} required decimalMin={1} decimalMax={200} integeronly maxlength={3}
                            onValChange={v => {
                                dispatch(updateFormData(null,null,{ FeesAndDeposits: calculateFeesAndDeposits(formData.FeeForApplication, formData.DepositAmount, v)})) 
                            }} 
                            hideWhen={!formData.FeeForSupplementaryLoginID} />
                <Field.Text id="FeesAndDeposits" label={formLocalization.field_amount} numericComma readonly />
            </Section> 
            <Section id={part_3_ID} titleText={formLocalization.part_3_SignInfo} inline={props.inline}>
                <Field.Dropdown id="SubscriberType" label={formLocalization.SubscriberType} required options={formLocalization.field_subscriberType_list} />
                <Field.Text id="OLS1_NameEN" label={formLocalization.OLS1_NameEN} maxlength={50} required multiline={true}  
                            eMeLabel={getFieldStatus("OLS1_NameEN").autofilled && !getFieldStatus("OLS1_NameEN").edited} 
                            onChange={(value) => handleFieldChange("OLS1_NameEN", value)} />
                <Field.Text id="SignatoryTitle" label={formLocalization.SignatoryTitle} maxlength={50} required multiline={true} 
                            hideWhen={!formData.SubscriberType || formData.SubscriberType === "0"} />
                <Field.FileUpload   id="IdDocAttach" label={formLocalization.IdDocAttach} 
                                    limit="5242880" filter=".jpg,.png,.pdf" required={true} 
                                    groupNotes={props.readOnly || formData.SubscriberType !== "1" ? null : 
                                        [  
                                            formLocalization.IdDocAttach_notes(),
                                        ]} 
                                    hideWhen={!formData.SubscriberType || (formData.SubscriberType === "0" && formData.BR_CR_PI_PN_Type === "3")} />
            </Section>
        </StepContext.Provider>
    ) 
};

export default {
    stepId: STEPID,
    title: TITLE,
    content: Particulars,
    focusFirstInput: true,
    validations: {},
};
